const marketReplacements = {
  MatchResultEP: (market) => ({
    ...market,
    name: market.name.replace(/\(.*\)/, "(2UP)")
  }),
};

export const applyMarketReplacmenets = (market) => (
  marketReplacements[market.market_type]?.(market) || market
);